import validator from "validator";

const phoneNumberRegExp = /^\(([2-9]\d{2})\)(\s)(\d{3})-(\d{4})$/;

export const required = (value, props) => {
  if (props.listOptions && !value) {
    return "Please select value";
  }

  if (!value || (props.isCheckable && !props.checked)) {
    return props.requiredValidationMessage
      ? props.requiredValidationMessage
      : "Value is required";
  }
};

export const email = (value, props) => {
  if (!validator.isEmail(value)) {
    return props.emailValidationMessage
      ? props.emailValidationMessage
      : `${value} is not a valid email.`;
  }
};

const isNeed = (value, props, components) => {
  if (components) {
    var number =
      components[`contactInfo*WorkPhone`][0].value ||
      components[`contactInfo*CellPhone`][0].value;
  }

  if (!number) return `Input phone number`;
  else return undefined;
};

const onlyDigigts = (value, fieldName) => {
  if (value) {
    if (!/^\d+$/.test(value)) return fieldName + " must contain only digits";
  }
};

export const phoneExtValidator = (value) => {
  var onlyDigits = onlyDigigts(value, "Phone ext");
  if (onlyDigits) {
    return onlyDigits;
  }
};

export const integerValidator = (value) => {
  if (value && !/^\d+$/.test(value)) {
    return "Value must contain only digits";
  }
};

export const zipCodeValidator = (value) => {
  var onlyDigits = onlyDigigts(value, "Zip Code");
  if (onlyDigits) {
    return onlyDigits;
  }

  // get the maxLength from component's props
  if (value && value.toString().trim().length !== 5) {
    return `Not a valid zip code`;
  }
};

export const zipCodeValidator20 = (value) => {
  var onlyDigits = onlyDigigts(value, "Zip Code");
  if (onlyDigits) {
    return onlyDigits;
  }
};

export const routingNumberValidator = (value) => {
  var onlyDigits = onlyDigigts(value, "Routing Number");
  if (onlyDigits) {
    return onlyDigits;
  }

  if (value.toString().trim().length !== 9) {
    return "Routing Number must be 9 digits";
  }
};

export const phonesValidator = (value, props, components) => {
  const isOneNumberEntered = isNeed(value, props, components);
  const isLt10Digits = lt10Digits(value);
  const isPhoneRegMatch = phoneRegMatch(value);

  if (
    isOneNumberEntered === undefined &&
    isLt10Digits === value &&
    isPhoneRegMatch === value
  ) {
    return;
  }
  if (isOneNumberEntered === undefined && !value) {
    return;
  }
  if (isLt10Digits !== value) {
    return isLt10Digits;
  }
  if (isPhoneRegMatch !== value) {
    return isPhoneRegMatch;
  }
};

const lt10Digits = (value) => {
  const val = value.replace(/[()_-\s]/g, "").length;
  if (val !== 10) {
    return `Phone number must be 10 digits length`;
  } else return value;
};

const phoneRegMatch = (value) => {
  const isMatched = phoneNumberRegExp.test(value);
  if (!isMatched) {
    return `Allowed ranges: [2–9] for the first digit.`;
  } else return value;
};

export const phoneValidator = (value, props) => {
  const isLt10Digits = lt10Digits(value);
  const isPhoneRegMatch = phoneRegMatch(value);

  if (isLt10Digits !== value) {
    return props.phoneValidationMessage
      ? props.phoneValidationMessage
      : isLt10Digits;
  }
  if (isPhoneRegMatch !== value) {
    return props.phoneValidationMessage
      ? props.phoneValidationMessage
      : isPhoneRegMatch;
  }
};

export const onlyLettersAndDigitsValidator = (value, props) => {
  if (value && !/^[a-zA-Z0-9.-\s]*$/.test(value)) {
    return props.onlyLettersAndDigitsValidationMessage
      ? props.onlyLettersAndDigitsValidationMessage
      : "Value must contain only letters and digits";
  }
};

export const maxNumberValueValidator = (value, props) => {
  if (value > props.maxNumberValue) {
    return props.maxNumberValueMessage
      ? props.maxNumberValueMessage
      : `Value must be not more than ${props.maxNumberValue}`;
  }
};

export const moneyValidator = (value) => {
  if (value && (!/^\d+\.?\d{0,10}$/.test(value) || !(parseFloat(value) > 0))) {
    return "Enter a valid amount";
  }
};

export const onlyLettersValidator = (value, props) => {
  if (value && !/^[a-zA-Z\s]*$/.test(value)) {
    return props.onlyLettersValidationMessage
      ? props.onlyLettersValidationMessage
      : "Value must contain only letters";
  }
};
